import { coreDefaultTheme } from '@kite-js/theme';
import { FontTheme } from '@kite-js/theme-types';
import weights from './weights';
import familiesByLanguage from './familiesByLanguage';
import faces from './faces';
import basicLineHeights from './basicLineHeights';
import tallerLineHeights from './tallerLineHeights';
import sizes from './sizes';

const font: FontTheme = {
    ...coreDefaultTheme.font,
    weights,
    familiesByLanguage,
    faces,
    basicLineHeights,
    tallerLineHeights,
    sizes,
    family: 'Interstate, Inter, “Helvetica Neue”, Helvetica, Arial, sans-serif',
};

export default font;
